import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const unSupendedApi = createAsyncThunk('co-users/unSuspend', async ({ requestHeaders }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/co-users/unSuspend`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(requestHeaders),
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const unSuspended = createSlice(
  {
    name: 'deleteGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [unSupendedApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [unSupendedApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [unSupendedApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default unSuspended;
